<template>
  <div class="mpf-u-margin-bottom-6">
    <p>
      For security reasons, your session automatically ends if you have not been active for 10
      minutes.
    </p>
    <p>If you were entering information, it has not been saved and you will need to re-enter</p>
  </div>
  <MpfButton v-if="tenantStore?.tenant?.tenantId" label="Start again" @click="startAgain" />
</template>

<script setup lang="ts">
  import { useTenantStore } from '../../stores/useTenantStore';

  import MpfButton from '../components/MpfButton/MpfButton.vue';
  import { router } from '../../router';
  import * as Sentry from '@sentry/vue';

  const tenantStore = useTenantStore();
  const startAgain = () => router.push(`/start`);

  Sentry.captureMessage(`Session timeout`, {
    level: 'info',
  });
</script>
